document.addEventListener('DOMContentLoaded', function () {
    const tabGroups = document.querySelectorAll('.hv2-tabs-row');

    tabGroups.forEach(function (tabGroup) {
        const tabItems = tabGroup.querySelectorAll('.hv2-tabs__tab-item');

        if (tabItems.length > 0) {
            const screenshot = tabGroup.querySelector('.hv2-tabs__tab-content .screenshot');
            const screenshotimg = tabGroup.querySelector('.hv2-tabs__tab-content .screenshotimg');
            const screenshotwebp = tabGroup.querySelector('.hv2-tabs__tab-content .screenshotwebp');

            // Make the first tab item active by default
            tabItems[0].classList.add('active');

            // Set the first image and alt text for the first item
            screenshot.src = tabItems[0].getAttribute('data-image');
            screenshotimg.srcset = tabItems[0].getAttribute('data-image');
            screenshotwebp.srcset = tabItems[0].getAttribute('data-imagewebp');
            screenshot.alt = tabItems[0].getAttribute('data-alt');
            screenshot.style.opacity = "1";
            screenshot.style.transform = "translateY(0)";

            // Add click event listeners to other tab headings
            const tabHeadings = tabGroup.querySelectorAll('.hv2-tabs__tab-item-heading');
            tabHeadings.forEach(function (heading) {
                heading.addEventListener('click', function (event) {
                    event.preventDefault();
                    const tabItem = this.closest('.hv2-tabs__tab-item');
                    
                    // Remove active class from all items and close their dropdowns
                    tabItems.forEach(function (item) {
                        if (item !== tabItem) {
                            item.classList.remove('active');
                        }
                    });
                    
                    // Toggle the active state for the clicked item
                    tabItem.classList.toggle('active');

                    const imageSrc = tabItem.getAttribute('data-image');
                    const imageAlt = tabItem.getAttribute('data-alt');
                    const imageSrcWebp = tabItem.getAttribute('data-imagewebp');

                    // Hide the current image and dropdown effect
                    screenshot.style.opacity = "0";
                    screenshot.style.transform = "translateY(40px)";

                    // Update the images after the animation delay
                    setTimeout(function () {
                        screenshot.src = imageSrc;
                        screenshot.alt = imageAlt;
                        screenshotimg.srcset = imageSrc;
                        screenshotwebp.srcset = imageSrcWebp;
                        screenshot.style.opacity = "1";
                        screenshot.style.transform = "translateY(0)";
                    }, 600);
                });
            });
        }
    });
});
